import { module } from 'modujs';
import { Swiper, Keyboard, Navigation, Thumbs, Autoplay } from 'swiper';
import { body } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        Swiper.use([Keyboard, Navigation, Thumbs, Autoplay]);

        this.image = this.$('image')[0];
        this.texte = this.$('text')[0];
        this.articles = this.$('article')[0];
        this.editContinu = this.$('edit-continu')[0];

        this.imageContainer = this.$('image-container')[0];
        this.texteContainer = this.$('text-container')[0];

        this.arrowPrev = this.$('prev')[0];
        this.arrowNext = this.$('next')[0];

        this.arrowPrevArticle = this.$('article-prev')[0];
        this.arrowNextArticle = this.$('article-next')[0];

        this.editName = document.querySelector('[data-edit-name]');
        this.editPhoto = document.querySelector('[data-edit-photo]');
        this.editStyle = document.querySelector('[data-edit-style]');

        this.p = document.querySelector('.c-category_slide-p');

        this.sliderArticles;

        this.imageContainer.addEventListener('mouseenter', () => {
            document.querySelector('.c-home_slider-legende').classList.add('is-visible')
        })

        this.imageContainer.addEventListener('mouseleave', () => {
            document.querySelector('.c-home_slider-legende').classList.remove('is-visible')
        })

        let colors = [];
        let square_color = document.querySelector('.c-aside_colors');

        document.querySelectorAll('[data-color]').forEach(color => {
            colors.push(color.dataset.color);
        })

        this.sliderTexte = new Swiper(this.texteContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
            autoHeight: true
        })

        this.sliderImage = new Swiper(this.imageContainer, {
            speed: 300,
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            threshold: 3,
            centeredSlides: true,
            autoplay: {
                delay: 12000,
                disableOnInteraction: true
            },
            navigation: {
                prevEl: this.arrowPrev,
                nextEl: this.arrowNext
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            thumbs: {
                swiper: this.sliderTexte
            },
            on: {
                slideChange: (swiper) => {
                    let active_color = swiper.slides[swiper.activeIndex].dataset.color;
                    this.call('updateLazy', null, 'Scroll');

                    this.sliderTexte.slideTo(swiper.realIndex);

                    body.style.backgroundColor = active_color;
                    this.arrowPrev.style.color = active_color;
                    this.arrowNext.style.color = active_color;

                    this.editName.innerHTML = swiper.slides[swiper.activeIndex].dataset.collection;
                    this.editPhoto.innerHTML = swiper.slides[swiper.activeIndex].dataset.photo;
                    this.editStyle.innerHTML = swiper.slides[swiper.activeIndex].dataset.style;
                    this.editName.parentNode.style.color = active_color;

                    if (window.innerWidth < 700) {
                        this.arrowPrevArticle.style.color = active_color;
                        this.arrowNextArticle.style.color = active_color;
                    }

                    square_color.dataset.order = swiper.realIndex;

                    if (!this.editContinu) {
                        if (this.sliderArticles) this.sliderArticles.destroy();

                        this.currentSlide = document.querySelector('.c-home_slider-text .swiper-slide-active').dataset.current;

                        this.articleContainer = this.$('article-container');
                        this.articleContainer.forEach(sliderArticle => {
                            if (sliderArticle.dataset.slidersEdit !== this.currentSlide) {
                                sliderArticle.style.display = "none";
                            } else {
                                sliderArticle.style.display = "block";

                                this.sliderArticles = new Swiper(sliderArticle, {
                                    speed: 300,
                                    loop: true,
                                    slidesPerView: 1,
                                    navigation: {
                                        prevEl: this.arrowPrevArticle,
                                        nextEl: this.arrowNextArticle
                                    },
                                    on: {
                                        afterInit: (swiper) => {
                                            let activeSlide = swiper.slides[swiper.activeIndex];
                                            this.call('updateLazy', null, 'Scroll');

                                            document.querySelector('.-category_title').innerHTML = activeSlide.dataset.catTitle;
                                            document.querySelector('.-category_slide-title').innerHTML = activeSlide.dataset.title;
                                            this.p.innerHTML = activeSlide.dataset.excerpt;
                                            this.p.setAttribute('href', activeSlide.dataset.href)

                                        },

                                        slideChange: (swiper) => {
                                            let activeSlide = swiper.slides[swiper.activeIndex];
                                            this.call('updateLazy', null, 'Scroll');

                                            document.querySelector('.-category_title').innerHTML = activeSlide.dataset.catTitle;
                                            document.querySelector('.-category_slide-title').innerHTML = activeSlide.dataset.title;
                                            this.p.innerHTML = activeSlide.dataset.excerpt;
                                            this.p.setAttribute('href', activeSlide.dataset.href)

                                        }
                                    }
                                })
                            }
                        })
                    }
                }
            }
        })

        this.texteContainer.addEventListener('mouseenter', e => {
            this.sliderImage.autoplay.stop()
        })

        this.texteContainer.addEventListener('mouseleave', e => {
            this.sliderImage.autoplay.start()
        })

        if (this.editContinu) {
            this.articleContainer = this.$('article-container')[0];

            this.sliderArticles = new Swiper(this.articleContainer, {
                speed: 300,
                loop: true,
                slidesPerView: 1,
                navigation: {
                    prevEl: this.arrowPrevArticle,
                    nextEl: this.arrowNextArticle
                },
                on: {
                    afterInit: (swiper) => {
                        let activeSlide = swiper.slides[swiper.activeIndex];
                        this.call('updateLazy', null, 'Scroll');

                        document.querySelector('.-category_title').innerHTML = activeSlide.dataset.catTitle;
                        document.querySelector('.-category_slide-title').innerHTML = activeSlide.dataset.title;
                        this.p.innerHTML = activeSlide.dataset.excerpt;
                        this.p.setAttribute('href', activeSlide.dataset.href)

                    },

                    slideChange: (swiper) => {
                        let activeSlide = swiper.slides[swiper.activeIndex];
                        this.call('updateLazy', null, 'Scroll');

                        document.querySelector('.-category_title').innerHTML = activeSlide.dataset.catTitle;
                        document.querySelector('.-category_slide-title').innerHTML = activeSlide.dataset.title;
                        this.p.innerHTML = activeSlide.dataset.excerpt;
                        this.p.setAttribute('href', activeSlide.dataset.href)

                    }
                }
            })
        }

    }

    destroy() {
        if (this.sliderImage) this.sliderImage.destroy()
        if (this.sliderTexte) this.sliderTexte.destroy()
        if (this.sliderArticles) this.sliderArticles.destroy()

        this.sliderImage = null;
        this.sliderTexte = null;
        this.sliderArticles = null;

        body.style.backgroundColor = '#ffffff';
    }
}